<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('AirExport.NextLegEntry')"
    :width="$selectByLang('400px', '430px')"
    :close-on-click-modal="false"
  >
    <el-form :label-width="$selectByLang('100px', '130px')" label-position="left">
      <el-form-item :label="$t('AirExport.ActualFlight')">
        <el-input v-model="form.actualFlight" style="width: 150px" no="1" />
      </el-form-item>
      <el-form-item label="ATD：">
        <el-date-picker v-model="form.atd" type="date" value-format="yyyy-MM-dd" style="width: 120px" clearable no="2" />
      </el-form-item>
      <el-form-item :label="$t('AirExport.NextLegInformation')">
        <el-input v-model="form.onwardJourney" type="textarea" :rows="6" style="width: 284px" no="3" />
      </el-form-item>
    </el-form>
    <div slot="footer" style="margin: 0 auto;width: fit-content;">
      <el-button type="primary" no="4" @click="okClickHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
      <el-button no="5" @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import { batchUpdate } from '@/api/AirExport/airExportJob'

export default {
  name: 'FlightTrackerDialog',
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: this.visible,
      form: new AirExportJob().fillDefaultValue().getData()
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.form = { ...this.job }
      }
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    okClickHandler() {
      if (!this.form.actualFlight) {
        this.$message.warning(this.$t('AirExport.ActualFlightCannotBeEmpty'))
        return
      }
      if (!this.form.atd) {
        this.$message.warning(this.$t('AirExport.ActualDepartureDate'))
        return
      }
      if (!this.form.onwardJourney) {
        this.$message.warning(this.$t('AirExport.NextInformationCannotBeEmpty'))
        return
      }
      const loading = getLoading4Cxt(this)
      batchUpdate([this.form], { selectiveType: 'atd', airSelectiveType: 'actualFlight,onwardJourney' }).then(res => {
        loading.close()
        this.innerVisible = false
        this.$emit('callback', res.data[0])
      }).catch(() => {
        loading.close()
      })
    }
  }
}
</script>
